import type { ChannelLastMessage } from '../../types/CommunityChannel';
import { messageContentToPlainText } from './messageContentToPlainText';

/**
 * Compact text shown under a channel row — "@username: body". The
 * body is run through `messageContentToPlainText` so Slate-DOM JSON
 * is flattened into readable prose instead of leaking the raw
 * `[{"type":"paragraph",...}]` payload into the row. Falls back to
 * "@username" alone when the message has no text body (media-only),
 * and to an empty string when there's no last message yet.
 */
export function getLastMessagePreview(
  lastMessage: ChannelLastMessage | undefined,
): string {
  if (!lastMessage) return '';
  const username = lastMessage.profile?.username
    ? `@${lastMessage.profile.username}`
    : '@unknown';
  const textContent = lastMessage.content?.textContent;
  if (!textContent) return username;
  const body = messageContentToPlainText(
    textContent.content,
    textContent.type,
  ).trim();
  if (!body) return username;
  return `${username}: ${body}`;
}
